import * as React from "react";
import * as _ from "lodash";
import './ActivationForm.css';
import { Trans, useTranslation, withTranslation } from "react-i18next";
import { useFormState, useFormDispatch } from "./Context/ActivationFormContext"
import RedwoodInputText from '../../../common/Input/RedwoodInputText';
import RedwoodSelect from '../../../common/Select/RedwoodSelect';
import { hasVisibleValue, isOracleEmailAddress, normalizeInputValue, regExp } from '../../../common/Validators';
import PasswordComponent from "./Password/PasswordComponent";
import * as Bowser from "bowser";
import { shouldRestrictToOracleEmail, shouldSkipPhonebookCheckAccess, TENLS_URL_FORMAT, themeOn } from "../../../config/apiConfig";
import SendMetrics from "../../../CourierService/SendMetrics";
import SendLogs from "../../../CourierService/SendLogs";
import TermsOfUseComponent from "../../TermsOfUse/TermsOfUseComponent";
import Notifier from "../../../common/Notifier/Notifier";
import RedwoodModal from "../../../common/Modal/RedwoodModal";
import { keysIn } from "lodash";
import { PRE_GA_TAG, RegionBuildStatus } from '../../../Constants/regionBuildStatus';
import {
  fetchAccountNameValidation,
  fetchBanner,
  fetchRegions,
  fetchStateId,
  getFeatureFlag
} from "../../../CourierService/FetchService";
import RedwoodCheckbox from "../../../common/Checkbox/RedwoodCheckbox";
import PhoneInput from "react-phone-input-2";
import countries from "../../../common/CountriesInfo.json";
import {isRestrictedCountry} from "../../../common/Helper";
import ThrottlingBanner from "../../ThrottlingBanner/ThrottlingBanner";
import ODBGModal from "../../ODBGModal/ODBGModal";
import {
  buildDefaultPhonebookOptions,
  mergePhonebookOptions,
} from "./phonebookOptions";
import { buildRefreshedPhonebookValidationState } from "./phonebookValidationState";
const DUPLO_DEFAULT_TENANCY_NAME = "bmc_operator_access";
const DUPLO_DEFAULT_PROVIDER_NAME = "ocna-saml";
const DUPLO_TENANT_PREFILL_KEY = "pb_duplo_tenant_prefill";
const PHONEBOOK_AUTH_RESULT_CHANNEL = "pb_viewmore_auth_result";
const PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL = "pb_phonebook_check_access_result";
const PHONEBOOK_ACTIVE_CHECK_ACCESS_REQUEST_ID = "pb_active_phonebook_check_access_request_id";


const FormDisplay = () => {
  const dispatch = useFormDispatch()
  const [touched, setTouched] = React.useState({});
  const [filterRegions, setFilterRegions] = React.useState<boolean>(false);
  const [regionGroups, setRegionGroups] = React.useState<any[]>([]);
  const [acceptRegionRestrictions, setAcceptRegionRestrictions] = React.useState(false);
  const [homeRegionList, setHomeRegionList] = React.useState<any[]>([]);
  const [perfillError, setPerfillError] = React.useState<boolean>(false);
  const [passwordError, setPasswordError] = React.useState({passwordValid: null, matchPassword: null});
  const [tenancyNameChanged, setTenancyNameChanged] = React.useState<boolean>(false);
  const [validateTenancyURLChanged, setValidateTenancyURLChanged] = React.useState<boolean>(false);
  const [updateStateList, setUpdateStateList] = React.useState(false);
  const [customerTypePublicOffer, setCustomerTypePublicOffer] = React.useState<string>('INDIVIDUAL');
  const {t, i18n} = useTranslation();
  const isEnglishTranslation = i18n.language === "en";
  const token = new URLSearchParams(window.location.search).get('activationToken');
  const errorState = {isValid: true, value: '', errorMsg: ''};

  const {
    user_session,
    apiError,
    render,
    firstName,
    lastName,
    emailAddress,
    tenancyName,
    dataCenterRegion,
    dataCenterRegionId,
    serviceGroupNames,
    homeRegion,
    regionGroup,
    homeRegions,
    showBanner,
    isInternalCustomerType,
    domainType,
    tenancyTypes,
    partyName,
    alternatePartyName,
    alternateEnglishName,
    customerPhoneNumber,
    address,
    countryObject,
    countryInfo,
    statesList,
    selectedState,
    selectedProvince,
    addressValidationMessage,
    featureFlags,
    call2tenls,
    publicOffer,
    restrictedCountry,
    orderNumber,
    validateTenancyURL,
    api403Error,
    showODBGModal,
    tenancyClassSelectionEnabled,
    selectedTenancyClass,
    selectedPhoneBook,
    selectedUsageType,
    selectedServiceType,
    phoneBook,
    usageTypes,
    phonebooks
  } = useFormState();
  const shouldUseCorpSsoMetadataFlow =
    isInternalCustomerType && getFeatureFlag('enableEnhancedMetadataTags', featureFlags);
  const shouldRestrictEmailToOracle = shouldRestrictToOracleEmail(isInternalCustomerType);
  const skipPhonebookCheckAccess = shouldSkipPhonebookCheckAccess();

  const usageTypesArray = React.useMemo(() => {
    // if reducer accidentally stored { usageTypeList: [...] }
    if (Array.isArray(usageTypes)) return usageTypes;
    if (usageTypes && Array.isArray(usageTypes.usageTypeList)) {
      return usageTypes.usageTypeList;
    }
    return [];
  }, [usageTypes]);

  const usageTypeOptions = React.useMemo(() => {
    return usageTypesArray
        .filter((u: any) => u?.state === "ACTIVE") // optional
        .map((u: any) => ({ label: u.usagetype, value: u.usagetype }));
  }, [usageTypesArray]);

  const defaultPhonebookOptions = React.useMemo(() => {
    return buildDefaultPhonebookOptions(
      Array.isArray(phonebooks) ? phonebooks : [],
      shouldUseCorpSsoMetadataFlow,
      t("common.viewMore", "View more")
    );
  }, [t, phonebooks, shouldUseCorpSsoMetadataFlow]);
  const [phonebookOptions, setPhonebookOptions] = React.useState<any[]>(defaultPhonebookOptions);
  const [phonebookValidationError, setPhonebookValidationError] = React.useState<React.ReactNode>("");
  const [isPhonebookValidated, setIsPhonebookValidated] = React.useState<boolean>(false);
  const [hasViewMorePhonebooksLoaded, setHasViewMorePhonebooksLoaded] = React.useState<boolean>(false);
  const shouldAutoValidatePhonebookRef = React.useRef(false);
  const lastProcessedPhonebookAuthResultTimestampRef = React.useRef<number | null>(null);
  const validatedPhonebookValuesRef = React.useRef<Set<string>>(new Set());
  const inFlightPhonebookValidationValueRef = React.useRef<string | null>(null);
  const duploDefaultTenancyAppliedRef = React.useRef(false);
  const phonebookAuthPopupRef = React.useRef<Window | null>(null);
  const activePhonebookCheckAccessRequestIdRef = React.useRef<string | null>(null);
  const activePhonebookCheckAccessPromiseRef = React.useRef<Promise<{ ok: boolean; status: number }> | null>(null);
  const activePhonebookCheckAccessValueRef = React.useRef<string | null>(null);
  const activePhonebookCheckAccessCancelRef = React.useRef<(() => void) | null>(null);

  const validatePhonebookAccess = React.useCallback((selectedPhonebookValue: string) => {
    if (
      activePhonebookCheckAccessValueRef.current === selectedPhonebookValue &&
      activePhonebookCheckAccessPromiseRef.current
    ) {
      return activePhonebookCheckAccessPromiseRef.current;
    }

    activePhonebookCheckAccessCancelRef.current?.();

    const requestId = `pb-check-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const returnUrl = window.location.pathname + window.location.search;
    const checkAccessUrl =
      `/phonebook/view-more?returnUrl=${encodeURIComponent(returnUrl)}` +
      `&tenant=${encodeURIComponent(DUPLO_DEFAULT_TENANCY_NAME)}` +
      `&provider=${encodeURIComponent(DUPLO_DEFAULT_PROVIDER_NAME)}` +
      `&mode=check-access` +
      `&phonebook=${encodeURIComponent(selectedPhonebookValue)}` +
      `&requestId=${encodeURIComponent(requestId)}`;

    const validationPromise = new Promise<{ ok: boolean; status: number }>((resolve, reject) => {
      let settled = false;
      const parseStoragePayload = (raw: string | null) => {
        if (!raw) {
          return null;
        }
        try {
          return JSON.parse(raw);
        } catch {
          return null;
        }
      };
      const iframe = document.createElement("iframe");

      const cleanup = () => {
        window.removeEventListener("message", onMessage);
        window.removeEventListener("storage", onStorage);
        window.removeEventListener("focus", onFocus);
        window.clearTimeout(timeoutId);
        window.clearInterval(pollIntervalId);
        if (activePhonebookCheckAccessRequestIdRef.current === requestId) {
          activePhonebookCheckAccessRequestIdRef.current = null;
          sessionStorage.removeItem(PHONEBOOK_ACTIVE_CHECK_ACCESS_REQUEST_ID);
        }
        if (activePhonebookCheckAccessPromiseRef.current === validationPromise) {
          activePhonebookCheckAccessPromiseRef.current = null;
          activePhonebookCheckAccessValueRef.current = null;
          activePhonebookCheckAccessCancelRef.current = null;
        }
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      };

      const finalize = (handler: () => void) => {
        if (settled) {
          return;
        }

        settled = true;
        cleanup();
        handler();
      };

      activePhonebookCheckAccessCancelRef.current = () => {
        finalize(() => {
          reject(new Error("Phonebook access validation superseded"));
        });
      };

      const handlePayload = (payload: any) => {
        const activeRequestId =
          activePhonebookCheckAccessRequestIdRef.current ||
          sessionStorage.getItem(PHONEBOOK_ACTIVE_CHECK_ACCESS_REQUEST_ID);

        if (activeRequestId !== requestId) {
          return false;
        }

        if (payload?.type !== "PB_PHONEBOOK_CHECK_ACCESS_RESULT" || payload?.requestId !== requestId) {
          return false;
        }

        finalize(() => {
          window.localStorage.removeItem(PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL);

          if (!payload?.success) {
            reject(new Error(payload?.error || "Phonebook access validation failed"));
            return;
          }

          resolve({
            ok: !!payload?.ok,
            status: Number(payload?.status || 0),
          });
        });
        return true;
      };

      const onMessage = (event: MessageEvent) => {
        const expectedSource = iframe.contentWindow;
        if (event.origin !== window.location.origin || !expectedSource || event.source !== expectedSource) {
          return;
        }
        handlePayload(event.data);
      };

      const onStorage = (event: StorageEvent) => {
        if (event.key !== PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL) {
          return;
        }

        const payload = parseStoragePayload(event.newValue);
        if (!payload) {
          return;
        }

        handlePayload(payload);
      };

      const onFocus = () => {
        const payload = parseStoragePayload(window.localStorage.getItem(PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL));
        if (!payload) {
          return;
        }

        handlePayload(payload);
      };

      const pollForResult = () => {
        const payload = parseStoragePayload(window.localStorage.getItem(PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL));
        if (!payload) {
          return;
        }

        handlePayload(payload);
      };

      const timeoutId = window.setTimeout(() => {
        finalize(() => {
          reject(new Error("Phonebook access validation timed out"));
        });
      }, 60000);
      const pollIntervalId = window.setInterval(pollForResult, 250);

      window.addEventListener("message", onMessage);
      window.addEventListener("storage", onStorage);
      window.addEventListener("focus", onFocus);
      activePhonebookCheckAccessRequestIdRef.current = requestId;
      sessionStorage.setItem(PHONEBOOK_ACTIVE_CHECK_ACCESS_REQUEST_ID, requestId);
      window.localStorage.removeItem(PHONEBOOK_CHECK_ACCESS_RESULT_CHANNEL);

      iframe.setAttribute("title", "phonebook-check-access");
      iframe.setAttribute("aria-hidden", "true");
      iframe.style.display = "none";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.src = checkAccessUrl;
      document.body.appendChild(iframe);
    });
    activePhonebookCheckAccessValueRef.current = selectedPhonebookValue;
    activePhonebookCheckAccessPromiseRef.current = validationPromise;
    return validationPromise;
  }, []);

  const resetPhonebookValidationState = React.useCallback(() => {
    const refreshedValidationState = buildRefreshedPhonebookValidationState(phoneBook);
    validatedPhonebookValuesRef.current = refreshedValidationState.validatedPhonebookValues;
    inFlightPhonebookValidationValueRef.current = refreshedValidationState.inFlightPhonebookValidationValue;
    setPhonebookValidationError(refreshedValidationState.phonebookValidationError);
    setIsPhonebookValidated(refreshedValidationState.isPhonebookValidated);
    shouldAutoValidatePhonebookRef.current = refreshedValidationState.shouldAutoValidate;
  }, [phoneBook]);

  const buildPhonebookUnauthorizedError = React.useCallback((selectedPhonebookValue: string) => {
    const phonebookUrl = `https://devops.oci.oraclecorp.com/phonebook/${encodeURIComponent(selectedPhonebookValue)}`;

    return (
      <Trans
        i18nKey="activationForm.error.phoneBookUnauthorized"
        components={isEnglishTranslation ? {
          phonebookLink: <a href={phonebookUrl} target="_blank" rel="noopener noreferrer" aria-label="Phonebook">Phonebook</a>
        } : undefined}
      >
        Please contact the Phonebook owner to be added to the BOAT group with the appropriate permissions for this <a href={phonebookUrl} target="_blank" rel="noopener noreferrer">Phonebook</a>.
      </Trans>
    );
  }, [isEnglishTranslation]);

  const validateSelectedPhonebook = React.useCallback(async (selectedPhonebookValue: string) => {
    if (!shouldUseCorpSsoMetadataFlow || !selectedPhonebookValue) {
      setPhonebookValidationError("");
      setIsPhonebookValidated(!!selectedPhonebookValue);
      return;
    }

    if (!hasViewMorePhonebooksLoaded) {
      setPhonebookValidationError("");
      setIsPhonebookValidated(true);
      return;
    }

    if (skipPhonebookCheckAccess) {
      setPhonebookValidationError("");
      setIsPhonebookValidated(true);
      return;
    }

    if (validatedPhonebookValuesRef.current.has(selectedPhonebookValue)) {
      setPhonebookValidationError("");
      setIsPhonebookValidated(true);
      return;
    }

    if (inFlightPhonebookValidationValueRef.current === selectedPhonebookValue) {
      return;
    }

    setPhonebookValidationError("");
    setIsPhonebookValidated(false);
    inFlightPhonebookValidationValueRef.current = selectedPhonebookValue;

    try {
      const validationResponse = await validatePhonebookAccess(selectedPhonebookValue);
      if (validationResponse.status === 403 || !validationResponse.ok) {
        validatedPhonebookValuesRef.current.delete(selectedPhonebookValue);
        setPhonebookValidationError(buildPhonebookUnauthorizedError(selectedPhonebookValue));
        return;
      }

      validatedPhonebookValuesRef.current.add(selectedPhonebookValue);
      setIsPhonebookValidated(true);
    } catch (validationError) {
      if (validationError instanceof Error && validationError.message === "Phonebook access validation superseded") {
        return;
      }
      console.error("Phonebook access validation failed", validationError);
      validatedPhonebookValuesRef.current.delete(selectedPhonebookValue);
      setPhonebookValidationError(buildPhonebookUnauthorizedError(selectedPhonebookValue));
    } finally {
      if (inFlightPhonebookValidationValueRef.current === selectedPhonebookValue) {
        inFlightPhonebookValidationValueRef.current = null;
      }
    }
  }, [buildPhonebookUnauthorizedError, hasViewMorePhonebooksLoaded, shouldUseCorpSsoMetadataFlow, skipPhonebookCheckAccess, validatePhonebookAccess]);

  React.useEffect(() => {
    const applyPhonebookAuthResult = (payload: any) => {
      if (payload?.type !== "PB_VIEW_MORE_AUTH_RESULT" || !payload?.success) {
        return;
      }

      const payloadTimestamp = Number(payload?.timestamp || 0);
      if (
        payloadTimestamp > 0 &&
        lastProcessedPhonebookAuthResultTimestampRef.current === payloadTimestamp
      ) {
        return;
      }
      if (payloadTimestamp > 0) {
        lastProcessedPhonebookAuthResultTimestampRef.current = payloadTimestamp;
      }

      const responseJson = payload?.responseJson;
      const rawResponseText = payload?.rawResponseText;

      if (typeof rawResponseText === "string") {
        sessionStorage.setItem("pb_viewmore_raw_response", rawResponseText);
      }
      sessionStorage.setItem("pb_viewmore_response", JSON.stringify(responseJson ?? null));
      resetPhonebookValidationState();
      setHasViewMorePhonebooksLoaded(true);
      window.localStorage.removeItem(PHONEBOOK_AUTH_RESULT_CHANNEL);

      try {
        const mergedPhonebooks = mergePhonebookOptions(defaultPhonebookOptions as any, responseJson);
        setPhonebookOptions(mergedPhonebooks.options);
      } catch (parseError) {
        console.error("Failed to process popup phonebook response", parseError);
      }
    };

    const parseStoragePayload = (raw: string | null) => {
      if (!raw) {
        return null;
      }
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    };

    const onPhonebookAuthResult = (event: MessageEvent) => {
      const expectedPopup = phonebookAuthPopupRef.current;
      const isFromExpectedPopup = !!expectedPopup && event.source === expectedPopup;
      if (!isFromExpectedPopup) {
        return;
      }

      if (event.data?.type !== "PB_VIEW_MORE_AUTH_RESULT") {
        return;
      }

      phonebookAuthPopupRef.current = null;

      sessionStorage.removeItem("pb_auth_in_progress");
      applyPhonebookAuthResult(event.data);
    };

    const onStorageResult = (event: StorageEvent) => {
      if (event.key !== PHONEBOOK_AUTH_RESULT_CHANNEL) {
        return;
      }

      const payload = parseStoragePayload(event.newValue);
      if (!payload) {
        return;
      }

      sessionStorage.removeItem("pb_auth_in_progress");
      applyPhonebookAuthResult(payload);
    };

    const onWindowFocus = () => {
      const payload = parseStoragePayload(window.localStorage.getItem(PHONEBOOK_AUTH_RESULT_CHANNEL));
      if (!payload) {
        return;
      }

      sessionStorage.removeItem("pb_auth_in_progress");
      applyPhonebookAuthResult(payload);
    };

    window.addEventListener("message", onPhonebookAuthResult);
    window.addEventListener("storage", onStorageResult);
    window.addEventListener("focus", onWindowFocus);
    return () => {
      window.removeEventListener("message", onPhonebookAuthResult);
      window.removeEventListener("storage", onStorageResult);
      window.removeEventListener("focus", onWindowFocus);
    };
  }, [defaultPhonebookOptions, resetPhonebookValidationState]);

  React.useEffect(() => {
    setPhonebookOptions(defaultPhonebookOptions);
    setHasViewMorePhonebooksLoaded(false);
    shouldAutoValidatePhonebookRef.current = false;

    const rawPhonebookResponse = sessionStorage.getItem("pb_viewmore_response");
    if (!rawPhonebookResponse) {
      return;
    }

    try {
      const parsed = JSON.parse(rawPhonebookResponse);
      resetPhonebookValidationState();
      setHasViewMorePhonebooksLoaded(true);
      const mergedPhonebooks = mergePhonebookOptions(defaultPhonebookOptions as any, parsed);

      // After view-more returns data, keep only actual phonebook options
      // from manager hierarchy plus popup results that are not already present,
      // and remove the view-more action item.
      setPhonebookOptions(mergedPhonebooks.options);
    } catch (error) {
      console.error("Failed to parse phonebook response", error);
    }
  }, [defaultPhonebookOptions, resetPhonebookValidationState]);

  React.useEffect(() => {
    if (!hasViewMorePhonebooksLoaded || !shouldAutoValidatePhonebookRef.current) {
      return;
    }

    shouldAutoValidatePhonebookRef.current = false;

    const selectedPhonebookValue = String(phoneBook ?? "").trim();
    if (!selectedPhonebookValue) {
      return;
    }

    void validateSelectedPhonebook(selectedPhonebookValue);
  }, [hasViewMorePhonebooksLoaded, phoneBook, validateSelectedPhonebook]);

  const unavailableError = React.useMemo(() => t('activationForm.error.unavailable', 'The chosen Cloud Account Name is unavailable'), [t]);

  const formText: {[key: string]: {[key: string]: string | any }} = {
    label: {
      newAccountInformation: t('activationForm.label', "New Cloud Account Information"),
      firstName: t('activationForm.firstName', 'First Name'),
      lastName: t('activationForm.lastName', 'Last Name'),
      email: t('activationForm.email', 'Email'),
      tenancyName: t('activationForm.tenancyName', 'Cloud Account Name'),
      regionGroup: t('activationForm.regionGroup', 'Region Group'),
      homeRegion: t('activationForm.homeRegion', 'Home Region'),
      tenancyType: t('activationForm.tenancyType', 'Cloud Account Type'),
      partyName: t('activationForm.partyName', 'Legal Company Name'),
      alternatePartyName: t('activationForm.alternatePartyName', 'Alternate English Legal Company Name'),
      address1: t('personalInfo.address1', 'Street Address'),
      address2: t('personalInfo.address2', 'Apartment, Unit, Floor or PO Box'),
      address3: t('personalInfo.address3', 'Address Line 3'),
      address4: t('personalInfo.address4', 'Address Line 4'),
      city: t('personalInfo.city', 'City'),
      state: t('personalInfo.state', 'State'),
      province: t('personalInfo.province', 'Province'),
      postalCode: t('personalInfo.postalCode', 'Postal Code'),
      county: t('personalInfo.county', 'County/Municipality'),
      altEnglishName: t('personalInfo.altName', 'Alternate Name'),
      altNamePlaceholder: t('personalInfo.altNamePlaceholder', 'Enter your full name in English characters'),
      tenancyClassification: t('personalInfo.tenancyClass', 'Tenancy Classification'),
      phoneBook: t('activationForm.phoneBook', 'Phonebook'),
      usageType: t('activationForm.usageType', 'Usage Type'),
      serviceType: t('activationForm.serviceType', 'Service Type')
    },
    info: {
      tenancyName: <Trans i18nKey="activationForm.tenancyNameInfoTemp">Avoid including personal or confidential information when creating a cloud account name, since it cannot be changed later, and the name will be visible in the login URL. <br/><br/>The Cloud Account Name must start with a letter, use only English letters, numbers, hyphens, and underscores, and be 50 or less characters long. The name will be assigned to your company's or organization's environment when signing into the Console.</Trans>,
      homeRegion: <Trans
        i18nKey="activationForm.homeRegionInfo"
        components={isEnglishTranslation ? {
          serviceAvailabilityLink: <a href="https://www.oracle.com/cloud/cloud-regions/data-regions/#northamerica" target='_blank' rel="noopener noreferrer" aria-label="OCI service availability">OCI service availability</a>
        } : undefined}
      >See <a href="https://www.oracle.com/cloud/cloud-regions/data-regions/#northamerica" target='_blank' rel="noopener noreferrer">OCI service availability</a> by Regions. SaaS applications are provisioned in the geo-region specified on your order.</Trans>,
      tenancyType: <Trans i18nKey="activationForm.tenancyTypeInfo">Lightweight Domain Tenancy should be used by Internal Oracle Service teams that need a tenancy for service principals, or any Tenancy that is used as part of region build or host/run service components. This cannot be changed or modified once the tenancy is created.</Trans>,
      usageType: <Trans i18nKey="activationForm.usageTypeInfo">Type of workload that will run on the tenancy.</Trans>,
      serviceType: <Trans i18nKey="activationForm.serviceTypeInfo">Type of service that will be running in this tenancy.</Trans>
    },
    phoneBookSelectionInfo: {
      phoneBookSelection: <Trans i18nKey="activationForm.phoneBookSelection">Please select a phonebook.</Trans>
    },
    checkbox: {
      commercial: t('activationForm.checkboxCommercial', 'By selecting this box, you acknowledge that your home region cannot be changed after this step in the activation process.'),
      serbiaCommercial: t('activationForm.serbiaCommercial', 'By selecting this box, you acknowledge that your home region cannot be changed after this step in the activation process. You will only be able to create tenancies in the Oracle Serbia Central data center, in accordance with Oracle region isolation design principles. Resources in a tenancy inside Oracle Serbia Central Region cannot natively integrate with Oracle Cloud Services in other commercial region groups.'),
      euSovereign: <Trans
        i18nKey="activationForm.checkboxEuSovereign"
        components={isEnglishTranslation ? {
          serviceDescriptionsLink: <a href="https://www.oracle.com/contracts/cloud-services/" target='_blank' rel="noopener noreferrer" aria-label="Service Descriptions and Oracle PaaS and IaaS Public Cloud Services Pillar Document">Service Descriptions and Oracle PaaS and IaaS Public Cloud Services Pillar Document</a>
        } : undefined}
      >By selecting this box, you acknowledge that your home region cannot be changed after this step in the activation process. Please see the <a href="https://www.oracle.com/contracts/cloud-services/" target='_blank' rel="noopener noreferrer">Service Descriptions and Oracle PaaS and IaaS Public Cloud Services Pillar Document</a> for additional details and terms that apply to the EU Sovereign Cloud. This region has restrictions and cannot natively integrate with other Cloud Services in other Regions.</Trans>
    },
    validation: {
      altEnglishName: t('regExpr.altEnglishName', 'Use only English letters and spaces.')
    }
  }

  const [error, setError] = React.useState({
    firstName:errorState,
    lastName:errorState,
    email:errorState,
    tenancyName:errorState,
    regionGroup:errorState,
    homeRegion:errorState,
    partyName: errorState,
    alternatePartyName: errorState,
    altEnglishName: errorState,
    customerPhoneNumber: errorState,
    address1: errorState,
    address2: errorState,
    address3: errorState,
    address4: errorState,
    city: errorState,
    postalCode: errorState,
    state: errorState,
    province: errorState,
    country: errorState,
    county: errorState
  });

  const resetErrorFromCountrySelect = () => {
    setError({...error,...{
      regionGroup:errorState,
      homeRegion:errorState,
      altEnglishName: errorState,
      customerPhoneNumber: errorState,
      address1: errorState,
      address2: errorState,
      address3: errorState,
      address4: errorState,
      city: errorState,
      postalCode: errorState,
      state: errorState,
      province: errorState,
      country: errorState,
      county: errorState}})
  }

  const phoneBookChosen = !shouldUseCorpSsoMetadataFlow || !!selectedPhoneBook;
  const showPhonebookGuidance = shouldUseCorpSsoMetadataFlow && !phoneBookChosen;

  const set403Error = React.useCallback((msg: string) => {
      dispatch({ type: 'UPDATE_API403ERROR', payload: "boolean", boolean: true});
      if (!_.isEmpty(msg)) {
        dispatch({ type: 'UPDATE_API403ERROR_MSG', payload: msg});
      }
    }, [dispatch])

  const getErrorText = (type?: string, insert?: string) => {
    switch (type) {
      case "required":
        return <Trans i18nKey="activationForm.error.required">A value for {{insert}} is required.</Trans>;
      case "length":
        return <Trans i18nKey="activationForm.error.length">Cloud account name must be 50 characters or less.</Trans>;
      case "regExpr":
        return <Trans i18nKey="activationForm.error.regExpr">Input requirements for {{insert}} not met.</Trans>;
      case "tenancyReq":
        return <Trans i18nKey="activationForm.error.tenancyReq">Cloud account does not meet requirements.</Trans>
      default:
        return t('activationForm.error.gen', 'Error');
    }
  }

  const passwordErrorFlag = (name: any, value: any) => {
    setPasswordError(passwordError => {
      return{...passwordError, ...{[name]: value}}
    });
  };

  const setApiError = React.useCallback(() => {
    if (!apiError) {
      dispatch({
        type:'UPDATE_APIERROR',
        payload: 'boolean',
        boolean: true
      });
    } else {
      setPerfillError(true);
    };
  },[dispatch, apiError]);

  const getEmailValidationResult = React.useCallback((rawValue: string) => {
    const normalizedValue = normalizeInputValue('email', rawValue);

    if (!hasVisibleValue(rawValue)) {
      return {
        isValid: false,
        value: '',
        errorMsg: t(
          'activationForm.error.required',
          'A value for {{insert}} is required.',
          { insert: formText.label.email }
        )
      };
    }

    if (!normalizedValue.match(regExp.email)) {
      return {
        isValid: false,
        value: '',
        errorMsg: t(
          'activationForm.error.regExpr',
          'Input requirements for {{insert}} not met.',
          { insert: formText.label.email }
        )
      };
    }

    if (shouldRestrictEmailToOracle && !isOracleEmailAddress(normalizedValue)) {
      return {
        isValid: false,
        value: '',
        errorMsg: t('activationForm.error.oracleEmailRequired', 'Non oracle emails are not allowed in this environment')
      };
    }

    return {
      isValid: true,
      value: normalizedValue,
      errorMsg: ''
    };
  }, [formText.label.email, shouldRestrictEmailToOracle, t]);

  const onChangeHandler = (e: { target: { name: any; }; }, action: string, payload: any) => {
    dispatch({
      type:`${action}`,
      payload: payload
    });
    setTouched({...touched, [e.target.name]: true})
  }

  const onBlurHandler = (e: { target: { value: string; name: string; }; }, pattern: string, action: string, message?: string) => {
    const rawValue = e.target?.value ?? '';
    const name = e.target?.name;
    const val = normalizeInputValue(name, rawValue);
    const trimmedVal = rawValue.trim();
    dispatch({type: `${action}`, payload: val});

    setTouched({...touched, [name]: false})

    if (name === 'email') {
      const emailValidation = getEmailValidationResult(rawValue);
      setError(error => {
        return {
          ...error,
          email: {
            isValid: emailValidation.isValid,
            value: emailValidation.value,
            errorMsg: emailValidation.errorMsg
          }
        }
      });
      setTouched({...touched, [name]: emailValidation.isValid});
      return;
    }

    if (name === "postalCode" && !trimmedVal.match(pattern)) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: _.isString(message) ? t(`regExpr.${message}`) : ''}}}
      });
      setTouched({...touched, [name]: true})
    } else if (pattern === '-1') {
      setError(error => {
        return {...error, ...{[name]: {isValid: true, value: val, errorMsg: ''}}}
      });
      setTouched({...touched, [name]: true})
    } else if(!hasVisibleValue(rawValue)) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: message && message !== '' ? message : getErrorText("required", formText.label[name])}}}
      });
    } else if(!val.match(pattern) || trimmedVal === '') {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: message && message !== '' ? message : getErrorText("regExpr", formText.label[name])}}}
      });
    } else {
      setError(error => {
        return {...error, ...{[name]: {isValid: true, value: val, errorMsg: ''}}}
      });
      setTouched({...touched, [name]: true})
    }
  }

  const changeCustomerType = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const { value } = e.currentTarget;
    dispatch({ type: 'UPDATE_CUSTOMER_TYPE_PO', payload: value });
    setCustomerTypePublicOffer(value);
    setAcceptRegionRestrictions(false);
  };

  const resetPartyName=()=>{
    if (customerTypePublicOffer !== 'ORGANIZATION') {
      onBlurHandler({target: {value: '', name: 'partyName'}}, regExp.organization, 'UPDATE_PARTY_NAME');
      setError({ ...error, partyName: errorState });
    }
  }

  const updatePartyNameEvent = (type: string) => {
    switch (type) {
      case 'individual':
        onBlurHandler({target: {value: `${firstName} ${lastName}`, name: 'partyName'}}, regExp.organization, 'UPDATE_PARTY_NAME');
        break;
      case 'organization':
      default:
        resetPartyName();
        break;
    }
  };

  const countriesList = () => {
    const keys:any = [];

    // START: Codex Edit
    Object.keys(countries.countries)
      .filter((item) => !isRestrictedCountry(item))
      .forEach((item) => {
        keys.push({ value: item, label: t(`countries.${item}`) });
      });
    // END: Codex Edit

    keys.sort((a:any, b:any) => ((a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1));
    return keys;
  };

  const getCountyLabel = () => {
    // Check for edge cases and display if necessary.
    // This is required because you can't store translated words in translation files and they're
    // not intended to translate further.
    if (_.get(countryInfo, 'addressFields.County[1]', '') !== '') {
      if (address.country === 'MX') {
        return 'Municipio';
      }

      if (address.country === 'CL') {
        return 'Comuna';
      }
      return t(`personalInfo.${_.get(countryInfo, 'addressFields.County[1]')}`);
    }
    return t('personalInfo.county', 'County');
  };

  // Check Available Tenancy Name
  React.useEffect(() => {
    function setTenancyError(setting: boolean) {
      if (setting) {
        setError(error => {
          return {...error, ...{tenancyName: {isValid: false, value: '', errorMsg: unavailableError.toString()}}}
        });
      } else {
        setError(error => {
          return {...error, ...{tenancyName: {isValid: true, value: tenancyName, errorMsg: ''}}}
        });
        setTouched({...touched, tenancyName: true})
      };
    }

    if (tenancyNameChanged || validateTenancyURLChanged) {
      fetchAccountNameValidation(tenancyName, call2tenls, domainType, validateTenancyURL)
      .then(async accountNameValidationResult => {
        setTenancyNameChanged(false);
        setValidateTenancyURLChanged(false);
        if ([403, 429].includes(accountNameValidationResult.status)) {
          set403Error((await accountNameValidationResult.json()).message);
        } else if(![200, 204].includes(accountNameValidationResult.status)) {
          setTenancyError(true);
          SendMetrics({name:"ActivationValidateTenancyName.Count.Metrics.Error", value:1, userSession:user_session});
        } else {
          setTenancyError(false);
          SendMetrics({name:"ActivationValidateTenancyName.Count.Metrics", value:1, userSession:user_session});
        }
      }).catch(error => {
        setTenancyError(true);
        SendLogs({severity: 40000, message: `Validate updated tenancy name fail: ${error.message}, orderNumber: ${orderNumber}`, userSession:user_session});
        SendMetrics({name:"ActivationValidateTenancyName.Count.Metrics.Fail", value:1, userSession:user_session});
      });
    }
  },[tenancyName, tenancyNameChanged, touched, setTouched, unavailableError, user_session, domainType, featureFlags, homeRegion, call2tenls, orderNumber, validateTenancyURL, validateTenancyURLChanged, set403Error]);


  const onBlurTenancyNameHandler = (e: { target: { value: string; name: any; }; }, pattern: string, action: string) => {
    let val = e.target.value.trim()
    const name = e.target.name;
    dispatch({type: `${action}`, payload: val});

    setTouched({...touched, [name]: false})

    if(val.length === 0) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: getErrorText("required", formText.label[name])}}}
      });
    } else if (val.length > 50) {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: getErrorText("length", formText.label[name])}}}
      });
    } else if(!val.match(pattern) || val === '') {
      setError(error => {
        return {...error, ...{[name]: {isValid: false, value: '', errorMsg: getErrorText("tenancyReq", formText.label[name])}}}
      });
    } else {
      setTenancyNameChanged(true);
    }
  }

  const updateTouched = (name: any, value: any) => {
    setTouched(touched => {
      return{...touched, ...{[name]: value}}
    });
  };

  const checkboxTextRegionGroups = (region: string) => {
    const defaultText = formText.checkbox.commercial;

    if (region) {
      if (region.includes('EU Sovereign')) {
        return formText.checkbox.euSovereign;
      }
      if (region.includes('Serbia')) {
        return formText.checkbox.serbiaCommercial;
      }
    }
    return defaultText;
  }

  // Browser, OS and Platform Metrics
  React.useEffect(() => {
    const userAgent = Bowser.parse(window.navigator.userAgent);

    //Browser
    const browserName = userAgent.browser.name? userAgent.browser.name : "";
    const knownBrowserList: {[key: string]: string} = {
      'Chrome': 'Chrome.Count.Metrics',
      'Safari': 'Safari.Count.Metrics',
      'Firefox': 'Firefox.Count.Metrics',
      'Microsoft Edge': 'Edge.Count.Metrics',
      'Internet Explorer': 'IE.Count.Metrics'
    }

    if(knownBrowserList[browserName]) {
      SendMetrics({name: "Activation." + knownBrowserList[browserName], value:1, userSession: user_session});
    } else {
      SendMetrics({name: "ActivationUnknown.Count.Metrics", value: 1, userSession: user_session});
    }

    //OS
    const osname = userAgent.os.name? userAgent.os.name : "";
    const knownOSList: {[key: string]: string} = {
      'macOS': 'Mac.Count.Metrics',
      'Linux': 'Linux.Count.Metrics',
      'Windows': 'Windows.Count.Metrics'
    }

    if(knownOSList[osname]) {
      SendMetrics({name: "Activation." + knownOSList[osname], value: 1, userSession: user_session});
    }

    //Platform
    const platform = userAgent.platform.type? userAgent.platform.type : "";
    const knownPlatformList: {[key: string]: string} = {
      'desktop': 'Desktop.Count.Metrics',
      'mobile': 'Mobile.Count.Metrics',
      'tablet': 'Tablet.Count.Metrics',
    }

    if (knownPlatformList[platform]){
      SendMetrics({name: "Activation." + knownPlatformList[platform], value: 1, userSession: user_session});
    }
  }, [render, user_session]);

  // GET Home regions list
  React.useEffect(() => {
    // serviceGroupNames to check
    const serviceGroupNamesCheck = [
      "MOATOUTCOMES",
      "MOATANALYTICS",
      "MOATPRO",
      "MOATREACH",
      "DATAAPPEND",
      "OPTIMIZATIONODC",
      "CONTEXTODC",
      "CXUNITY"
    ];

    // push to serviceGroupNames for local only
    // serviceGroupNames.push("MOATOUTCOMES", "UGBUGAM");
    // serviceGroupNames.push("UGBUGAM");

    // fake result for local only
    // const result = mockRegionsResponse;

    const regionIdString: string = dataCenterRegionId && dataCenterRegionId !== '' ? '&dataCenterRegion=' + dataCenterRegionId : '';
    const requestString: string = `/region${call2tenls ? 's':''}?${serviceGroupNames 
                                                                && serviceGroupNames.length > 0 ? 
                                                        'serviceType=' + serviceGroupNames.map(s => s.toUpperCase()) : ''}${dataCenterRegion ? ('&classicDataCenterRegionId=' + dataCenterRegion + regionIdString) : ''}`;

    fetchRegions(requestString, call2tenls, publicOffer)
    .then(async res => {
      if(res.status === 200) {
        const result = await res.json();
        let list: any[] = [];
        // @ts-ignore
        let regions: string[] = [...new Set([...result.items.flatMap(item => [...new Set(item.homeRegions.map(h => h.regionGroup))])])];
        if (regions.length > 1) {
          setRegionGroups(regions.map((item, k) => ({label: item, value: item})));
        }
        if(serviceGroupNames.length > 0) {
          serviceGroupNames.forEach((serviceGroupName =>{
            if (serviceGroupNamesCheck.includes(serviceGroupName)) {
              setFilterRegions(true)
            }
          }));
        }

        if (filterRegions) {
          if (serviceGroupNames.includes("CXUNITY")) {
            // eslint-disable-next-line
            result.items.filter((homeRegion: { homeRegions: any[]; id: any; regionName: any; }) => {
              if( homeRegion.id === "NORTH_AMERICA_REGION" || homeRegion.id === "EMEA_REGION" || homeRegion.id === "APAC_REGION") {
                return homeRegion
              }})
            .map((homeRegion: { homeRegions: any[]; id: any; regionName: any; }) => { 
              const subList = homeRegion.homeRegions.map(subRegion => {
                let regionLabel = subRegion.regionName;
                if (
                  isInternalCustomerType &&
                  (subRegion.regionBuildStatus === RegionBuildStatus.INACTIVE)
                ) {
                  regionLabel += PRE_GA_TAG;
                }
                return({label: regionLabel, value: {id: subRegion.id}, group: homeRegion.id, regionGroup: subRegion.regionGroup, domain: subRegion.domain});
              });
              const dataRegion = {label: homeRegion.regionName,value: homeRegion.id, options: subList}
              list = list.concat(dataRegion);
              return homeRegion;
            });
          } else {
            // eslint-disable-next-line
            result.items.filter((homeRegion: { homeRegions: any[]; id: any; regionName: any; }) => {
              if(homeRegion.id === "NORTH_AMERICA_REGION") {
                return homeRegion
              }})
            .map((homeRegion: { homeRegions: any[]; id: any; regionName: any; }) => { 
              const subList = homeRegion.homeRegions.map(subRegion => {
                let regionLabel = subRegion.regionName;
                if (
                  isInternalCustomerType &&
                  (subRegion.regionBuildStatus === RegionBuildStatus.INACTIVE)
                ) {
                  regionLabel += PRE_GA_TAG;
                }
                return({label: regionLabel, value: {id: subRegion.id}, group: homeRegion.id, regionGroup: subRegion.regionGroup, domain: subRegion.domain});
              });
              const dataRegion = {label: homeRegion.regionName,value: homeRegion.id, options: subList}
              list = list.concat(dataRegion);
              return homeRegion;
            });
          }
        } else {
          result.items.map((homeRegion: { homeRegions: any[]; id: any; regionName: any; }) => {
            const subList = homeRegion.homeRegions.map(subRegion => {
              let regionLabel = subRegion.regionName;
              if (
                  isInternalCustomerType &&
                  (subRegion.regionBuildStatus === RegionBuildStatus.INACTIVE)
              ) {
                regionLabel += PRE_GA_TAG;
              }
              return({label: regionLabel, value: {id: subRegion.id}, group: homeRegion.id, regionGroup: subRegion.regionGroup, domain: subRegion.domain});
            });
            const dataRegion = {label: homeRegion.regionName,value: homeRegion.id, options: subList}
            list = list.concat(dataRegion);
            return homeRegion;
          });
        }
        if (dataCenterRegion === 'DED-ONPREM' || dataCenterRegion === 'DED-COLO' || serviceGroupNames.includes('ORACLEDBATAZURE')) {
          // @ts-ignore
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: "object",
            object: list
          });
          setHomeRegionList(list);
        } else {
          dispatch({
            type: 'HOME_REGIONS_LIST',
            payload: "object",
            object: list
          });
          setHomeRegionList(list);
        }
      }

      if(res.status >= 400) {
        if ([403, 429].includes(res.status)) {
          set403Error((await res.json()).message);
        } else {
          SendMetrics({name:"ActivationRegion.Count.Metrics.Error", value:1, userSession:user_session});
          setApiError();
        }
      }
      SendLogs({severity: 20000, message: `GET Home regions list successful, orderNumber: ${orderNumber}`, userSession:user_session});
      SendMetrics({name:"ActivationRegion.Count.Metrics", value:1, userSession:user_session});
    }).catch(error => {
      if (_.includes(_.toString(error), 'TypeError')) {
        set403Error('NetworkError');
      }
      console.info(error);
      SendLogs({severity: 40000, message: `GET Home regions list error: ${error.message}, orderNumber: ${orderNumber}`, userSession:user_session});
      SendMetrics({name:"ActivationRegion.Count.Metrics.Fail", value:1, userSession:user_session});
      setApiError();
    });
  }, [render, dispatch, user_session, setApiError, dataCenterRegion, dataCenterRegionId, serviceGroupNames, setFilterRegions, filterRegions, acceptRegionRestrictions, token, featureFlags, call2tenls, orderNumber, publicOffer, set403Error, isInternalCustomerType]);

  React.useEffect(() => {
    if (homeRegionList.length > 0 && regionGroup !== null) {
      let filteredHomeRegionListByRegionGroup = homeRegionList.map(item => {
        return {...item, options: item.options.filter((option: any) => option.regionGroup === regionGroup.value)};
      }).filter(row => row.options.length > 0);

      dispatch({
        type: 'HOME_REGIONS_LIST',
        payload: "object",
        object: filteredHomeRegionListByRegionGroup
      });
    }
  }, [regionGroup, dispatch, homeRegionList]);

  React.useEffect(() => {
    if (
      duploDefaultTenancyAppliedRef.current ||
      !shouldUseCorpSsoMetadataFlow ||
      !!(tenancyName && tenancyName.trim().length > 0)
    ) {
      return;
    }

    const duploTenantPrefill = sessionStorage.getItem(DUPLO_TENANT_PREFILL_KEY);
    const tenancyPrefill = duploTenantPrefill && duploTenantPrefill.trim();

    if (!tenancyPrefill) {
      return;
    }

    duploDefaultTenancyAppliedRef.current = true;
    dispatch({ type: "UPDATE_TENANCY_NAME", payload: tenancyPrefill });
    setTenancyNameChanged(true);
  }, [dispatch, shouldUseCorpSsoMetadataFlow, tenancyName]);

  // GET banner
  React.useEffect(() => {
    if (!call2tenls){ // Per Abdul, ignore banners call in Tenls activation flow
    const checkBanner = (bannerStartTime: number, bannerEndTime: number) => {
      const currentTime = new Date().getTime();
      if (currentTime >= bannerStartTime && currentTime <= bannerEndTime) {
        dispatch({
          type: "UPDATE_SHOW_BANNER",
          payload: "boolean",
          boolean: true
        });
      }
    };

    fetchBanner()
    .then(async res => {
      if(res.status === 200) {
          const result = await res.json();
          // second item in array for activation
          const banner = result.items[1];
          if (banner) {
            dispatch({
              type: "UPDATE_BANNER_CONTENT",
              payload: "object",
              object: banner
            });
          }
          checkBanner(Date.parse(banner.startTime), Date.parse(banner.endTime));
      }
      if(res.status >= 400) {
        if ([403, 429].includes(res.status)) {
          set403Error((await res.json()).message);
        }
        SendMetrics({name:"ActivationBanner.Count.Metrics.Error", value:1, userSession:user_session});
      }
      SendLogs({severity: 20000, message: `GET banner list successful, orderNumber: ${orderNumber}`, userSession:user_session});
      SendMetrics({name:"ActivationBanner.Count.Metrics", value:1, userSession:user_session});
    }).catch(error => {
      SendLogs({severity: 40000, message: `GET banner list error: ${error.message}, orderNumber: ${orderNumber}`, userSession:user_session});
      SendMetrics({name:"ActivationBanner.Count.Metrics.Fail", value:1, userSession:user_session});
    })
    }
  }, [user_session, dispatch, orderNumber, set403Error, call2tenls]);

  // Validate preset values
  React.useEffect(() => {
    let keys = keysIn(touched)

    const presetValidation = async(e: { target: { value: string; name: any; }; }, action: string) => {
      let val = e.target.value.trim()
      const name = e.target.name;
      setTouched(touched => {
        return{...touched, ...{[name]: true}}
      });
      dispatch({type: `${action}`, payload: val});
    }

    if (firstName && firstName.length > 1 && keys.indexOf('firstName') < 0) {
      const fName: { target: { value: string; name: any; }} = { target: { name: 'firstName', value: firstName}};
      const setFname = async () => {
        await presetValidation(fName, 'UPDATE_FIRST_NAME');
      }
      setFname();
    }

    if (lastName && lastName.length > 1 && keys.indexOf('lastName') < 0) {
      const lName: { target: { value: string; name: any; }} = { target: { name: 'lastName', value: lastName}};
      const setLname = async () => {
        await presetValidation(lName, 'UPDATE_LAST_NAME');
      }
      setLname();
    }

    if (emailAddress && emailAddress.length > 1 && keys.indexOf('email') < 0) {
      const setEmail = async () => {
        const emailValidation = getEmailValidationResult(emailAddress);
        dispatch({ type: 'UPDATE_EMAIL_ADDRESS', payload: normalizeInputValue('email', emailAddress) });
        setError(error => {
          return {
            ...error,
            email: {
              isValid: emailValidation.isValid,
              value: emailValidation.value,
              errorMsg: emailValidation.errorMsg
            }
          }
        });
        setTouched(touched => {
          return {...touched, email: emailValidation.isValid}
        });
      }
      setEmail();
    }

    if (tenancyName && tenancyName.length > 1 && keys.indexOf('tenancyName') < 0) {
      const tName: { target: { value: string; name: any; }} = { target: { name: 'tenancyName', value: tenancyName}};
      const setTenancyName = async () => {
        await presetValidation(tName, 'UPDATE_TENANCY_NAME');
      }
      setTenancyName();
    }

  },[firstName, lastName, emailAddress, tenancyName, dispatch, touched, setTouched, getEmailValidationResult]);

// touched.[inputName] is truthy means the input is touched and the field is valid | avoiding showing error if the input field is not touched
const checkValid = (inputName: string, current: boolean) => (touched as any)?.[inputName] && current;
// touched.[inputName] === false means errorMsg should be displayed
const checkError = (inputName: string, currentError: any) => (touched as any)?.[inputName] === false ? currentError : '';


  const disableContinue = () => {
    if(showBanner){
      return true;
    }

    const errorCheck = () => {
      const eflags: string[] = [];
      Object.entries(error).forEach(key =>  {
        // Checking if a field is required and if it's empty or invalid
        if (isRequiredField(key[0], publicOffer) && (!key[1].isValid || key[1].value === '')) {
          eflags.push("true");
        } else {
          eflags.push("false");
        }
      });
      const eflag = eflags.find((flag) => flag === "true") ? true : false;
      return eflag
    }

    const passCheck = () => {
      if (passwordError.passwordValid && passwordError.matchPassword) {
        return false;
      }
      return true;
    }

    const checkboxCheck = () => {
      return !acceptRegionRestrictions;
    }

    const requiredSelectsCheck = () => {
      if (!shouldUseCorpSsoMetadataFlow) {
        return false;
      }
      return !selectedPhoneBook ||
        (hasViewMorePhonebooksLoaded && !isPhonebookValidated) ||
        !selectedUsageType ||
        !selectedServiceType;
    }

    const tenancyTypeRequiredCheck = () => {
      if (!isInternalCustomerType || themeOn === true) {
        return false;
      }
      return !domainType || !domainType.value;
    }

    const flag: boolean =
      errorCheck() ||
      passCheck() ||
      checkboxCheck() ||
      requiredSelectsCheck() ||
      tenancyTypeRequiredCheck();

    return flag;
  }

  React.useEffect(() => {
    let statesList = [];
    if (_.get(address, 'country', '') !== '' && updateStateList) {
      fetchStateId(address.country)
        .then(async (res) => {
        if (res.status === 200) {
          statesList = await res.json();
          const statesFromApi = statesList != null
              && statesList.items.map((state: any) => ({ value: { id: state.id }, label: state.name }));
          dispatch({
            type: 'UPDATE_STATES_LIST',
            payload: 'object',
            object: statesFromApi
          });
        } else {
          if ([403, 429].includes(res.status)) {
            set403Error((await res.json()).message);
          }
          dispatch({
            type: 'UPDATE_STATES_LIST',
            payload: 'object',
            object: null
          });
        }
      }).catch((e) => {
        dispatch({
          type: 'UPDATE_STATES_LIST',
          payload: 'object',
          object: null
        });
      });
      setUpdateStateList(false);
    }
  },[countryInfo, address.country, address, dispatch, updateStateList, set403Error])

  const closeErrorModal = () => {
    dispatch({
      type:'UPDATE_APIERROR',
      payload: 'boolean',
      boolean: false
    });
  }

  const setValidateTenancyURL = (domain: string) => {
    if (domain){
      setValidateTenancyURLChanged(true);
      dispatch({
        type: 'UPDATE_VALIDATE_TENANCY_URL',
        payload: _.replace(TENLS_URL_FORMAT, '%s',  domain)
      })
    }
  };


  const isRequiredField = (name: string, publicOffer?:boolean) => {
    switch (name) {
      case 'address1':
        return _.get(countryInfo, 'addressFields.Address1[0]', '').startsWith('R');
      case 'address2':
        return _.get(countryInfo, 'addressFields.Address2[0]', '').startsWith('R');
      case 'address3':
        return _.get(countryInfo, 'addressFields.Address3[0]', '').startsWith('R');
      case 'address4':
        return _.get(countryInfo, 'addressFields.Address4[0]', '').startsWith('R');
      case 'city':
        return _.get(countryInfo, 'addressFields.City[0]', '').startsWith('R');
      case 'county':
        return _.get(countryInfo, 'addressFields.County[0]', '').startsWith('R');
      case 'state':
        return _.get(countryInfo, 'addressFields.State[0]', '').startsWith('R');
      case 'province':
        return _.get(countryInfo, 'addressFields.Province[0]', '').startsWith('R');
      case 'postalCode':
        return _.get(countryInfo, 'addressFields.PostalCode[0]', '').startsWith('R');
      case 'partyName':
        return customerTypePublicOffer === 'ORGANIZATION';
      case 'alternatePartyName':
        return ['JP','CN', 'TW', 'KR'].includes(address.country.toUpperCase()) && customerTypePublicOffer === 'ORGANIZATION';
      case 'alternateEnglishName':
        return ['JP','CN', 'TW', 'KR'].includes(address.country.toUpperCase());
      case 'customerPhoneNumber':
        return publicOffer ?? false;
      case 'tenancyName':
      case 'email':
      case 'firstName':
      case 'lastName':
        return true;
      default:
        return false;
    }
  };

  // @ts-ignore
  return (
    <>
      <div className="upperContentContainer">
        {apiError &&
          <RedwoodModal
            onClose={() => closeErrorModal()}
            show={true}
            buttonName={"Close"}
            wrapperClass={"sticky"}
          >
            <Notifier type="error" message={addressValidationMessage !== '' ? addressValidationMessage : t('activationForm.error.gen', "Error")} position={addressValidationMessage !== '' ? 'createAzureError' : perfillError ? 'apiError' : 'createError'} />
          </RedwoodModal>
        }
        {api403Error && <ThrottlingBanner />}
        {showODBGModal && <ODBGModal/> }
        <form autoComplete="on">
          <div className="title6">{formText.label.newAccountInformation}</div>
          {
              !tenancyClassSelectionEnabled && shouldUseCorpSsoMetadataFlow &&
              <div className="row">
                <div className="col-md-12 col-xs-12">
                  <RedwoodSelect
                      placeholder={formText.label.phoneBook}
                      label={formText.label.phoneBook}
                      name="phoneBook"
                      value={selectedPhoneBook}
                      info={!selectedPhoneBook}
                      infoMsg={formText.phoneBookSelectionInfo.phoneBookSelection}
                      error={!!phonebookValidationError}
                      errorIcon="error"
                      errorMsg={phonebookValidationError}
                      data={phonebookOptions}

                      onChange={async (e: any) => {
                        if (e?.value === "__VIEW_MORE__") {
                          const returnUrl = window.location.pathname + window.location.search;
                          sessionStorage.setItem("pb_viewmore_returnUrl", returnUrl);
                          const viewMoreAuthUrl = `/phonebook/view-more?returnUrl=${encodeURIComponent(returnUrl)}&tenant=${encodeURIComponent(DUPLO_DEFAULT_TENANCY_NAME)}&provider=${encodeURIComponent(DUPLO_DEFAULT_PROVIDER_NAME)}`;
                          const authWindow = window.open("", "_blank");
                          if (!authWindow) {
                            // Popup may be blocked by browser policy, so fall back to current-tab navigation.
                            window.location.assign(viewMoreAuthUrl);
                          } else {
                            try {
                              authWindow.location.replace(viewMoreAuthUrl);
                            } catch {
                              authWindow.location.href = viewMoreAuthUrl;
                            }
                            phonebookAuthPopupRef.current = authWindow;
                          }
                          return; // don't store __VIEW_MORE__
                        }

                        const selectedPhonebookValue = String(e?.value ?? "");
                        const previousPhonebookValue = String(phoneBook ?? "");

                        onChangeHandler({ target: { name: "phoneBook" } }, "UPDATE_SELECTED_PHONE_BOOK", e);
                        onBlurHandler(
                            { target: { name: "phoneBook", value: e.value } },
                            "-1",
                            "UPDATE_SELECTED_PHONE_BOOK_VALUE"
                        );

                        if (selectedPhonebookValue !== previousPhonebookValue) {
                          await validateSelectedPhonebook(selectedPhonebookValue);
                        }
                      }}

                      autoComplete="chrome-off"
                  />
                </div>
              </div>
          }
          { phoneBookChosen && <div>
          {shouldUseCorpSsoMetadataFlow && (
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <RedwoodSelect
                    placeholder={formText.label.usageType}
                    label={formText.label.usageType}
                    name="usageType"
                    value={selectedUsageType}
                    disabled={!phoneBookChosen}
                    info={true}
                    infoMsg={formText.info.usageType}
                    data={usageTypeOptions}
                    onChange={(e: any) => {
                      onChangeHandler({target: {name: "usageType"}}, 'UPDATE_SELECTED_USAGE_TYPE', e);
                      onBlurHandler({target: { name: "usageType", value: e.value }}, '-1', 'UPDATE_SELECTED_USAGE_TYPE_VALUE');
                    }}
                    autoComplete="chrome-off"
                />
              </div>
            </div>
          )}
          {shouldUseCorpSsoMetadataFlow && (
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <RedwoodSelect
                    placeholder={formText.label.serviceType}
                    label={formText.label.serviceType}
                    name="serviceType"
                    value={selectedServiceType}
                    disabled={!phoneBookChosen}
                    info={true}
                    infoMsg={formText.info.serviceType}
                    data={[{label: t('common.iaas', 'IaaS'), value: "IaaS"}, {label: t('common.saas', 'SaaS'), value: "SaaS"}, {label: t('common.paas', 'PaaS'), value: "PaaS"}]}
                    onChange={(e: any) => {
                      onChangeHandler({target: {name: "serviceType"}}, 'UPDATE_SELECTED_SERVICE_TYPE', e);
                      onBlurHandler({target: { name: "serviceType", value: e.value }}, '-1', 'UPDATE_SELECTED_SERVICE_TYPE_VALUE');
                    }}
                    autoComplete="chrome-off"
                />
              </div>
            </div>
          )}
          {publicOffer && <div className="row customer-type-select">
            <div className="col-md-12 col-xs-12">
              <label>
                <strong>{t('activationForm.customerType',"Customer Type")}</strong>
              </label>
              <div className="row">
                <div key="personal" className="col-xs-3">
                  <label aria-label="customer-type">
                    <input type="radio" id="individual-customer-radio" name="customer-type" checked={customerTypePublicOffer === 'INDIVIDUAL'} value="INDIVIDUAL" onClick={(e) => { changeCustomerType(e); updatePartyNameEvent('individual') }} />
                    {" " + t('activationForm.personal',"Personal")}
                  </label>
                </div>
                <div key="business" className="col-xs-3">
                  <label aria-label="customer-type">
                    <input type="radio" id="business-customer-radio" name="customer-type" checked={customerTypePublicOffer === 'ORGANIZATION'} value="ORGANIZATION" onClick={(e) => { changeCustomerType(e); updatePartyNameEvent('organization') }} />
                    {" " + t('activationForm.business',"Business")}
                  </label>
                </div>
              </div>
            </div>
          </div>}
          {publicOffer && <div className="row country-select">
            <div className="col-md-12 col-xs-12">
              <RedwoodSelect
                  placeholder={t('activationForm.placeholder.country', 'Country')}
                  label={t('activationForm.placeholder.country', 'Country')}
                  name="country"
                  value={countryObject}
                  data={countriesList()}
                  isPublicOffer={publicOffer}
                  required
                  error={restrictedCountry}
                  errorMsg={(
                      <Trans
                        i18nKey="activationForm.error.restrictedCountry"
                        components={isEnglishTranslation ? {
                          ociLink: <a href="https://www.oracle.com/cloud/why-oci/" target="_blank" rel="noreferrer" aria-label="learn more about Oracle Cloud Infrastructure">here</a>
                        } : undefined}
                      >
                        Free trials are currently not provided in this country.  If you are interested in learning more about Oracle Cloud Infrastructure (OCI), please click <a href="https://www.oracle.com/cloud/why-oci/" target="_blank" rel="noreferrer">here</a>.
                      </Trans>
                  )}
                  onChange={(e: any) => {
                    // @ts-ignore
                    const countryInfo = countries.countries[e.value];
                    if (isRestrictedCountry(e.value)) {
                      dispatch({
                        type: 'UPDATE_RESTRICTED_COUNTRY',
                        payload: 'boolean',
                        boolean: true
                      });
                      dispatch({
                        type: 'UPDATE_COUNTRY',
                        payload: "object",
                        object: {country: e.value, countryInfo, countryObject: e}
                      });
                      setTouched({"country": true});
                      setError(error => {
                        // eslint-disable-next-line
                        return {...error, ...{['country']: {isValid: false, value: e, errorMsg: ''}}}
                      });
                    } else {
                      dispatch({
                        type: 'RESET_PUBLIC_OFFER_FORM',
                        payload: ''
                      });
                      dispatch({
                        type: 'UPDATE_RESTRICTED_COUNTRY',
                        payload: 'boolean',
                        boolean: false
                      });
                      dispatch({
                        type: 'UPDATE_COUNTRY',
                        payload: "object",
                        object: {country: e.value, countryInfo, countryObject: e}
                      });
                      dispatch({ type: 'UPDATE_STATES_LIST', payload: 'object', object: null });
                      dispatch({ type: 'UPDATE_SELECTED_STATE', payload: 'object', object: null });
                      dispatch({ type: 'UPDATE_SELECTED_PROVINCE', payload: 'object', object: null });
                      setTouched({"country": true});
                      setError(error => {
                        // eslint-disable-next-line
                        return {...error, ...{['country']: {isValid: true, value: e, errorMsg: ''}}}
                      });
                      resetErrorFromCountrySelect();
                      setUpdateStateList(true);
                    }
                  }}
                  onBlur={(e: {target: { value: string; name: any; }}) => {
                    setError(error => {
                      return {...error, ...{[e.target.name]: {isValid: true, value: e, errorMsg: ''}}}
                    });
                    resetPartyName();
                  }}
                  autoComplete="chrome-off"
              />
            </div>
          </div>}
          {publicOffer && customerTypePublicOffer === 'ORGANIZATION' && <>
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    placeholder={t('personalInfo.organizationPlaceholder')}
                    isPublicOffer={publicOffer}
                    label={t('personalInfo.organization', 'Legal Company Name')}
                    name="partyName"
                    value={partyName}
                    required={customerTypePublicOffer === 'ORGANIZATION'}
                    valid={checkValid('partyName', isRequiredField('partyName') && error.partyName.isValid)}
                    error={checkError('partyName', isRequiredField('partyName') && error.partyName.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_PARTY_NAME', e.target.value)
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, regExp.organization, 'UPDATE_PARTY_NAME')}
                    autoComplete="organization"
                />
              </div>
            </div>
            {isRequiredField('alternatePartyName') &&
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={t('activationForm.alternatePartyName', 'Alternate English Legal Company Name')}
                    placeholder={t('signup.altEngCompanyNamePlaceholder', 'Enter alternate english company name')}
                    isPublicOffer={publicOffer}
                    name="alternatePartyName"
                    value={alternatePartyName}
                    required={isRequiredField('alternatePartyName')}
                    valid={checkValid('alternatePartyName', !isRequiredField('alternatePartyName') || error.alternatePartyName.isValid)}
                    error={checkError('alternatePartyName', isRequiredField('alternatePartyName') && error.alternatePartyName.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => { 
                      onChangeHandler(e, 'UPDATE_ALT_PARTY_NAME', e.target.value)
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, regExp.altEnglishCompanyName, 'UPDATE_ALT_PARTY_NAME')}
                />
              </div>
            </div>}
          </>}
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <RedwoodInputText
                  type="text"
                  placeholder={formText.label.firstName}
                  isPublicOffer={publicOffer}
                  label={formText.label.firstName}
                  name="firstName"
                  value={firstName? firstName : ""}
                  error={checkError('firstName', error.firstName.errorMsg)}
                  valid={checkValid('firstName', error.firstName.isValid)}
                  required
                  disabled={!phoneBookChosen}
                  onChange={(e: { target: { value: string; name: any; }; }) => {
                    onChangeHandler(e, 'UPDATE_FIRST_NAME', e.target.value);
                    onBlurHandler(e, regExp.personName, 'UPDATE_FIRST_NAME');
                  }}
                  autoComplete="given-name"
              />
            </div>
            <div className="col-md-6 col-xs-12">
              <RedwoodInputText
                  type="text"
                  placeholder={formText.label.lastName}
                  isPublicOffer={publicOffer}
                  label={formText.label.lastName}
                  name="lastName"
                  value={lastName? lastName : ""}
                  error={checkError('lastName', error.lastName.errorMsg)}
                  valid={checkValid('lastName', error.lastName.isValid)}
                  required
                  disabled={!phoneBookChosen}
                  onChange={(e: { target: { value: string; name: any; }; }) => {
                    onChangeHandler(e, 'UPDATE_LAST_NAME', e.target.value);
                    onBlurHandler(e, regExp.personName, 'UPDATE_LAST_NAME');
                  }}
                  autoComplete="family-name"
              />
            </div>
          </div>
          {publicOffer && <>
          {isRequiredField("alternateEnglishName") && <div className="row alt-name">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={formText.label.altEnglishName}
                    name="altEnglishName"
                    value={alternateEnglishName}
                    placeholder={formText.label.altNamePlaceholder}
                    required={isRequiredField("alternateEnglishName")}
                    valid={checkValid('altEnglishName',!isRequiredField("alternateEnglishName") || error.altEnglishName.isValid)}
                    error={checkError('altEnglishName',isRequiredField("alternateEnglishName") && error.altEnglishName.errorMsg)}
                    isPublicOffer={publicOffer}
                    onChange={(e: {target: { value: string; name: any; }; }) => {
                      onChangeHandler(e, 'UPDATE_ALT_ENGLISH_NAME', e.target.value);
                      onBlurHandler(e, regExp.altEnglishName, 'UPDATE_ALT_ENGLISH_NAME', formText.validation.altEnglishName);
                    }}
                />
              </div>
            </div>}
            <div className="row phone">
              <div className="col-md-12 col-xs-12">
                <PhoneInput
                    inputProps={{
                      name: 'customerPhoneNumber',
                      required: true,
                      autocomplete: 'tel'
                    }}
                    placeholder=""
                    areaCodes={{ ci: ['27'] }}
                    enableTerritories
                    isValid={error.customerPhoneNumber.isValid}
                    country={_.lowerCase(address.country)}
                    value={customerPhoneNumber}
                    onChange={(phone, data, e) => {
                      dispatch({
                        type: 'UPDATE_PHONE',
                        payload: phone.trim()
                      });
                      onBlurHandler(e, regExp.phoneNumber, 'UPDATE_PHONE')
                    }}
                />
                <div className="requiredLabel">{t('personalInfo.required', 'Required')}</div>
              </div>
            </div>
            {_.get(countryInfo, 'addressFields.Address1', '') !== '' &&
            <div className="row address1">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={`${_.get(countryInfo, 'addressFields.Address1[1]', '') !== '' ? 
                        t(`personalInfo.${_.get(countryInfo, 'addressFields.Address1[1]')}`) :
                        t('personalInfo.address1', 'Address Line 1')}`}
                    name="address1"
                    value={address.address1}
                    placeholder={t('personalInfo.addressPlaceholder')}
                    isPublicOffer={publicOffer}
                    required={_.get(countryInfo, 'addressFields.Address1[0]', '') === 'R'}
                    valid={checkValid('address1', error.address1.isValid)}
                    error={checkError('address1',error.address1.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_ADDRESS1', e.target.value);
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, '^.{1,240}$', 'UPDATE_ADDRESS1')}
                    autoComplete="address-line1"
                />
              </div>
            </div>}
            {_.get(countryInfo, 'addressFields.Address2', '') !== '' &&
            <div className="row address2">
                <div className="col-md-12 col-xs-12">
                  <RedwoodInputText
                      type="text"
                      label={`${_.get(countryInfo, 'addressFields.Address2[1]', '') !== '' ?
                          t(`personalInfo.${_.get(countryInfo, 'addressFields.Address2[1]')}`) :
                          t('personalInfo.address2', 'Address Line 2')}`}
                      name="address2"
                      value={address.address2}
                      placeholder={t('personalInfo.addressPlaceholder')}
                      isPublicOffer={publicOffer}
                      required={isRequiredField('address2')}
                      valid={checkValid('address2', !isRequiredField('address2') || error.address2.isValid)}
                      error={checkError('address2', isRequiredField('address2') && error.address2.errorMsg)}
                      onChange={(e: {target: { value: string; name: any; }}) => {
                        onChangeHandler(e, 'UPDATE_ADDRESS2', e.target.value);
                      }}
                      onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, isRequiredField('address2') ? '^.{1,240}$' : '-1', 'UPDATE_ADDRESS2')}
                      autoComplete="address-line2"
                  />
                </div>
            </div>}
            {_.get(countryInfo, 'addressFields.Address3', '') !== '' &&
            <div className="row address3">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={`${_.get(countryInfo, 'addressFields.Address3[1]', '') !== '' ?
                        t(`personalInfo.${_.get(countryInfo, 'addressFields.Address3[1]')}`) :
                        t('personalInfo.address3', 'Address Line 3')}`}
                    name="address3"
                    value={address.address3}
                    placeholder={t('personalInfo.addressPlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('address3')}
                    valid={checkValid('address3', !isRequiredField('address3') || error.address3.isValid)}
                    error={checkError('address3', isRequiredField('address3') && error.address3.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_ADDRESS3', e.target.value);
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, isRequiredField('address3') ? '^.{1,240}$' : '-1', 'UPDATE_ADDRESS3')}
                    autoComplete="address-line3"
                />
              </div>
            </div>}
            {_.get(countryInfo, 'addressFields.Address4', '') !== '' &&
            <div className="row address4">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={`${_.get(countryInfo, 'addressFields.Address4[1]', '') !== '' ?
                        t(`personalInfo.${_.get(countryInfo, 'addressFields.Address4[1]')}`) :
                        t('personalInfo.address4', 'Address Line 4')}`}
                    name="address4"
                    value={address.address4}
                    placeholder={t('personalInfo.addressPlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('address4')}
                    valid={checkValid('address4', !isRequiredField('address4') || error.address4.isValid)}
                    error={checkError('address4', isRequiredField('address4') && error.address4.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_ADDRESS4', e.target.value);
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, isRequiredField('address4') ? '^.{1,240}$' : '-1', 'UPDATE_ADDRESS4')}
                />
              </div>
            </div>}
            {_.get(countryInfo, 'addressFields.City', '') !== '' &&
            <div className="row city">
              <div className="col-md-12 col-xs-12">
                <RedwoodInputText
                    type="text"
                    label={`${address.country === 'CR' ?
                        'Canton' :
                        t('personalInfo.city', 'City')}`}
                    name="city"
                    value={address.city}
                    placeholder={t('personalInfo.cityPlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('city')}
                    valid={checkValid('city', !isRequiredField('city') || error.city.isValid)}
                    error={checkError('city', isRequiredField('city') && error.city.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_CITY', e.target.value);
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, regExp.cityRegex, 'UPDATE_CITY')}
                    autoComplete="address-level2"
                />
              </div>
            </div>}
            <div className="row">
              {_.get(countryInfo, 'addressFields.State', '') !== '' &&
              <div className="col-md-6 col-xs-12 state">
                {_.isArray(statesList) &&
                <RedwoodSelect
                    type="text"
                    data={statesList}
                    value={selectedState}
                    placeholder={t('personalInfo.statePlaceholder')}
                    isPublicOffer={publicOffer}
                    label={`${
                        _.get(countryInfo, 'addressFields.State[1]', '') !== ''
                            ? t(`personalInfo.${_.get(countryInfo, 'addressFields.State[1]')}`)
                            : t('personalInfo.state', 'State')
                    }`}
                    name="state"
                    required={isRequiredField('state')}
                    valid={checkValid('state', !isRequiredField('state') || error.state.isValid)}
                    error={checkError('state', isRequiredField('state') && error.state.errorMsg)}
                    onChange={(e: any) => {
                      const stateValue: string = countryObject.value.toUpperCase() === 'BR' ? _.split(e.value.id, '-')[1].trim() : e.label;
                      onChangeHandler({target: { name: "state" }}, 'UPDATE_STATE', stateValue);
                      dispatch({type: 'UPDATE_SELECTED_STATE', payload: 'object', object: e });
                      setError({...error,...{'state':{isValid:true,'errorMsg':'',value:e}}})
                    }}
                    autoComplete="address-level1"
                />}
                {!_.isArray(statesList) &&
                <RedwoodInputText
                    type="text"
                    label={`${
                        _.get(countryInfo, 'addressFields.State[1]', '') !== ''
                            ? t(`personalInfo.${_.get(countryInfo, 'addressFields.State[1]')}`)
                            : t('personalInfo.state', 'State')
                    }`}
                    name="state"
                    value={address.state}
                    placeholder={t('personalInfo.statePlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('state')}
                    valid={checkValid('state', !isRequiredField('state') || error.state.isValid)}
                    error={checkError('state', isRequiredField('state') && error.state.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_STATE', e.target.value);
                      setError({...error,...{'state':{isValid:true,'errorMsg':'',value:e.target.value}}});
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, '^.{1,60}$', 'UPDATE_STATE')}
                    autoComplete="address-level1"
                />
                }
              </div>}
              {_.get(countryInfo, 'addressFields.Province', '') !== '' &&
              <div className="col-md-6 col-xs-12 province">
                {_.isArray(statesList) &&
                    <RedwoodSelect
                        type="text"
                        label={`${
                            _.get(countryInfo, 'addressFields.Province[1]', '') !== ''
                                ? t(`personalInfo.${_.get(countryInfo, 'addressFields.Province[1]')}`)
                                : t('personalInfo.province', 'Province')
                        }`}
                        name="province"
                        value={selectedProvince}
                        data={statesList}
                        placeholder={t('personalInfo.provincePlaceholder')}
                        isPublicOffer={publicOffer}
                        required={isRequiredField('province')}
                        valid={checkValid('province', !isRequiredField('province') || error.province.isValid)}
                        error={checkError('province', isRequiredField('province') && error.province.errorMsg)}
                        onChange={(e: any) => {
                          onChangeHandler({target: { name: "province"}}, 'UPDATE_PROVINCE', e.label);
                          dispatch({type: 'UPDATE_SELECTED_PROVINCE', payload: 'object', object: e });
                          setError({...error,...{'province':{isValid:true,'errorMsg':'',value:e}}})
                        }}
                        autoComplete="address-level3"
                    />
                }
                {!_.isArray(statesList) &&
                <RedwoodInputText
                    type="text"
                    label={`${
                        _.get(countryInfo, 'addressFields.Province[1]', '') !== ''
                            ? t(`personalInfo.${_.get(countryInfo, 'addressFields.Province[1]')}`)
                            : t('personalInfo.province', 'Province')
                    }`}
                    name="province"
                    value={address.province}
                    placeholder={t('personalInfo.provincePlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('province')}
                    valid={checkValid('province', !isRequiredField('province') || error.province.isValid)}
                    error={checkError('province', isRequiredField('province') && error.province.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_PROVINCE', e.target.value);
                      setError({...error,...{'province':{isValid:true,'errorMsg':'',value:e.target.value}}});
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, isRequiredField('province') ? '^.{1,60}$' : '-1', 'UPDATE_PROVINCE')}
                    autoComplete="address-level3"
                />
                }
              </div>}
              {_.get(countryInfo, 'addressFields.PostalCode', '') !== '' &&
              <div className="col-md-6 col-xs-12 zipcode">
                <RedwoodInputText
                    type="text"
                    placeholder={t('personalInfo.zipPlaceholder')}
                    isPublicOffer={publicOffer}
                    label={t('personalInfo.zip', 'Zip/Postal Code')}
                    name="postalCode"
                    value={address.postalCode}
                    required={isRequiredField('postalCode')}
                    valid={checkValid('postalCode', !isRequiredField('postalCode') || error.postalCode.isValid)}
                    error={checkError('postalCode', isRequiredField('postalCode') && error.postalCode.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_POSTAL_CODE', e.target.value);
                      onBlurHandler(e, _.get(countryInfo, 'addressFields.PostalCode[1]', '^[0-9]{5}$'), 'UPDATE_POSTAL_CODE', _.get(countryInfo, 'addressFields.PostalCode[2]', ''))
                    }}
                    autoComplete="postal-code"
                />
              </div>}
              {_.get(countryInfo, 'addressFields.County', '') !== '' &&
              <div className="col-md-12 col-xs-12 county">
                <RedwoodInputText
                    type="text"
                    label={getCountyLabel()}
                    name="county"
                    value={address.county}
                    placeholder={t('personalInfo.countyPlaceholder')}
                    isPublicOffer={publicOffer}
                    required={isRequiredField('county')}
                    valid={checkValid('county', !isRequiredField('county') || error.county.isValid)}
                    error={checkError('county', isRequiredField('county') && error.county.errorMsg)}
                    onChange={(e: {target: { value: string; name: any; }}) => {
                      onChangeHandler(e, 'UPDATE_COUNTY', e.target.value)
                    }}
                    onBlur={(e: {target: { value: string; name: string; }}) => onBlurHandler(e, isRequiredField('county') ? '^.{1,60}$' : '-1', 'UPDATE_COUNTY')}
                    autoComplete="county"
                />
              </div>}
            </div>
          </>}
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <RedwoodInputText
                type="text"
                placeholder={formText.label.email}
                label={formText.label.email}
                name="email"
                autoComplete="email"
                value={emailAddress}
                valid={checkValid('email', error.email.isValid)}
                error={checkError('email', error.email.errorMsg)}
                required
                disabled={!phoneBookChosen}
                isPublicOffer={publicOffer}
                onChange={(e: { target: { value: string; name: any; }; }) => {
                  onChangeHandler(e, 'UPDATE_EMAIL_ADDRESS', e.target.value)
                  onBlurHandler(e, regExp.email, 'UPDATE_EMAIL_ADDRESS');
                }}
              />
            </div>
          </div>
          <div className="row">
            <PasswordComponent updateTouched={updateTouched} updatePasswordErrorFlag={passwordErrorFlag} passwordError={passwordError}/>
          </div>
          {
            tenancyClassSelectionEnabled && 
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <RedwoodSelect
                  placeholder={formText.label.tenancyClassification}
                  label={formText.label.tenancyClassification}
                  name="tenancyClassification"
                  value={selectedTenancyClass}
                  disabled={!phoneBookChosen}
                  data={[{label: t('common.internal', 'Internal'), value: "INTERNAL"}, {label: t('common.external', 'External'), value: "EXTERNAL"}]}
                  onChange={(e: any) => {
                    onChangeHandler({target: {name: "tenancyClassification"}}, 'UPDATE_SELECTED_TENANCY_CLASS', e);
                    onBlurHandler({target: { name: "tenancyClassification", value: e.value }}, '-1', 'UPDATE_SELECTED_TENANCY_CLASS_VALUE');
                  }}
                  autoComplete="chrome-off"
                />
              </div>
            </div>
          }
          {!themeOn && regionGroups && regionGroups.length > 1  &&
              <div className="row">
                <div className="col-md-12 col-xs-12" data-testid="regionGroupContainer">
                  <RedwoodSelect
                      placeholder={formText.label.regionGroup}
                      label={formText.label.regionGroup}
                      name="regionGroup"
                      disabled={!phoneBookChosen}
                      data={regionGroups}
                      value={regionGroup}
                      required
                      isPublicOffer={publicOffer}
                      onChange={(e: any) => {
                        setTouched({...touched, "regionGroup": true})
                        if (homeRegion !== null) {
                          dispatch({
                            type: 'UPDATE_HOME_REGION',
                            payload: "object",
                            object: null
                          })
                          setTouched({...touched, "homeRegion": errorState})
                        }
                        dispatch({
                          type: 'UPDATE_REGION_GROUP',
                          payload: "object",
                          object: e
                        })
                      }}
                      autoComplete="chrome-off"
                  />
                </div>
              </div>
          }
          <div className="row">
            <div className="col-md-12 col-xs-12" data-testid="homeRegionContainer">
              <RedwoodSelect
                placeholder={formText.label.homeRegion}
                label={formText.label.homeRegion}
                name="homeRegion"
                required
                disabled={!phoneBookChosen}
                value={homeRegion}
                data={homeRegions}
                info={themeOn !== true}
                isPublicOffer={publicOffer}
                infoMsg={formText.info.homeRegion}
                onChange={(e: any) => {
                  setTouched({...touched, "homeRegion": true})
                  if (acceptRegionRestrictions) setAcceptRegionRestrictions(false);
                  setValidateTenancyURL(e.domain);
                  dispatch({
                    type:`UPDATE_HOME_REGION`,
                    payload: "object",
                    object: e
                  });
                }}
                autoComplete="chrome-off"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xs-12" data-testid="homeRegionCheckboxContainer">
              <RedwoodCheckbox
                  checked={acceptRegionRestrictions}
                  disabled={!phoneBookChosen}
                  onChange={() => { setAcceptRegionRestrictions(!acceptRegionRestrictions); resetPartyName(); }}>
                {checkboxTextRegionGroups(regionGroup?.value)}
              </RedwoodCheckbox>
            </div>
          </div>
          {isInternalCustomerType && themeOn !== true &&
          <div className="row">
            <div className="col-md-12 col-xs-12"  data-testid="tenancyTypeContainer">
              <RedwoodSelect
                placeholder={formText.label.tenancyType}
                label={formText.label.tenancyType}
                name="tenancyType"
                value={domainType}
                data={tenancyTypes}
                required
                disabled={!phoneBookChosen}
                isPublicOffer={publicOffer}
                info={true}
                infoMsg={formText.info.tenancyType}
                onChange={(e: any) => {
                  setTenancyNameChanged(true);
                  setTouched({...touched, "domainType": true})
                  dispatch({
                    type:`UPDATE_DOMAIN_TYPE`,
                    payload: "object",
                    object: e
                  });
                }}
                autoComplete="chrome-off"
              />
            </div>
          </div>
          }
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <RedwoodInputText
                type="text"
                placeholder={formText.label.tenancyName}
                label={formText.label.tenancyName}
                name="tenancyName"
                value={tenancyName}
                error={checkError('tenancyName', error.tenancyName.errorMsg)}
                valid={checkValid('tenancyName', error.tenancyName.isValid)}
                info={true}
                infoMsg={formText.info.tenancyName}
                disabled={!phoneBookChosen}
                required
                onChange={(e: { target: { value: string; name: any } }) => {
                  onChangeHandler(e, "UPDATE_TENANCY_NAME", e.target.value);
                }}
                onBlur={(e: { target: { value: string; name: any } }) =>
                  onBlurTenancyNameHandler(
                    e,
                    _.get(domainType, "value", "") === "LIGHT_WEIGHT_DOMAIN"
                      ? regExp.tenancyLWD
                      : regExp.tenancy,
                    "UPDATE_TENANCY_NAME"
                  )
                }
                autoComplete="chrome-off"
              />
            </div>
          </div>
          <></>
          </div>
          }
        </form>
      </div>
      <TermsOfUseComponent
        isDisabled={disableContinue()}
        hideTitle={showPhonebookGuidance}
        customContent={showPhonebookGuidance ? (
          <div className="phonebookGuidance" data-testid="phonebookGuidance">
            <p>{t('activationForm.phonebookGuidanceOne', "Phonebooks are automatically filtered based on your management hierarchy. For example, you can view phonebooks owned by your manager as well as others who report to the same manager. This ensures you have access to phonebooks within your reporting structure.")}</p>
            <p>
              <Trans i18nKey="activationForm.phonebookGuidanceTwo">
                Click <strong>View More</strong> for all phonebooks (Requires Yubi-key).
              </Trans>
            </p>
            <p>
              <Trans
                i18nKey="activationForm.phonebookGuidanceThree"
                components={isEnglishTranslation ? {
                  onboardingGuideLink: <a href="https://internal-docs.oraclecorp.com/en-us/iaas/internalcontent/tools/phonebook/onboarding-phonebook.htm" target="_blank" rel="noopener noreferrer" aria-label="onboarding guide">onboarding guide</a>
                } : undefined}
              >
                If you do not already have a phonebook, check the <a href="https://internal-docs.oraclecorp.com/en-us/iaas/internalcontent/tools/phonebook/onboarding-phonebook.htm" target="_blank" rel="noopener noreferrer">onboarding guide</a> for details.
              </Trans>
            </p>
            <p>
              <Trans
                i18nKey="activationForm.phonebookGuidanceFour"
                components={isEnglishTranslation ? {
                  slackChannelLink: <a href="https://oracle.enterprise.slack.com/archives/CU7PZ8NNQ" target="_blank" rel="noopener noreferrer" aria-label="#oci_account_admin_tool">#oci_account_admin_tool</a>
                } : undefined}
              >
                For additional help that is not covered in the guide, contact <a href="https://oracle.enterprise.slack.com/archives/CU7PZ8NNQ" target="_blank" rel="noopener noreferrer">#oci_account_admin_tool</a>.
              </Trans>
            </p>
          </div>
        ) : undefined}
      />
    </>
  );
}

const ActivationFormContainer: React.FC<{}> = () => {
  return (
    <div className="contentContainer">
      <FormDisplay />
    </div>
  );
};

export default withTranslation()(ActivationFormContainer);
